<template>
	<div class="bc" :class="{'bc-short': mode == 'catalogDetail'}">
		<div class="wrapper-bc" :class="{'wrapper': mode != 'catalogDetail','wrapper-cd-bc': mode == 'catalogDetail', 'long': isScrolling}">
			<div class="bc-items" xmlns:v="http://rdf.data-vocabulary.org/#" itemprop="breadcrumb" ref="bcItemsContainer">
				<span v-for="(item, index) in items" :key="item" class="bc-item">
					<NuxtLink v-if="index != items.length - 1" :to="item.url_without_domain" rel="v:url" property="v:title">
						<span>{{ item.title }}</span>
					</NuxtLink>
					<span v-else class="bc-last" property="v:title">{{ item.title }}</span>
				</span>
			</div>
		</div>
	</div>
</template>

<script setup>
	const props = defineProps(['items', 'mode']);
	const bcItemsContainer = ref();
	let isScrolling = ref(null);

	//rwd
	const {mobileBreakpoint} = inject('rwd');

	onMounted(async () => {
		//mobile container scroll
		if (bcItemsContainer.value && mobileBreakpoint.value) {
			const containerWidth = bcItemsContainer.value.scrollWidth;
			const documentWidth = document.documentElement.clientWidth;

			if (containerWidth > documentWidth) {
				isScrolling.value = true;
				let scrollLeft = bcItemsContainer.value.getBoundingClientRect().right;
				bcItemsContainer.value.scrollTo({
					left: scrollLeft,
					behavior: 'smooth',
				});
			}
		}
	});
</script>

<style lang="less">
	.bc {
		font-size: 14px; color: #7891a9; padding-bottom: 12px;
		.bc-item {
			position: relative;
			& > a {
				text-decoration: none; color: @blue; padding: 0 13px 0 0; margin: 0 7px 0 0; position: relative; display: inline-flex;
				&:after { .icon-arrow-down(); font: 7px/7px @fonti; color: @textColor; position: absolute; top: 7px; right: 0; .rotate(-90deg); }
				@media (min-width: @t) {
					&:hover { color: @blue; text-decoration: underline; }
				}
			}
			&.active {
				& > a {
					text-decoration: underline;
					&:before { display: block; }
				}
			}
		}

		@media (max-width: @m) {
			font-size: 13px; padding-bottom: 7px;
			.bc-item > a { padding: 0 12px 0 0; margin: 0 5px 0 0; }
			.bc-last { white-space: nowrap; }
		}
		@media (max-width: @ms) {
			.bc-item {
				white-space: nowrap;
				& > a { margin-right: 5px; }
			}
			.bc-last { padding-right: 15px; white-space: nowrap; }
		}
	}
	.wrapper-bc {
		padding: 15px 0 0;
		@media (max-width: @ms) {
			position: relative;
			&.long:before { .pseudo(1px,22px); background: @borderColor; bottom: 0; left: 0; }
		}
	}
	.wrapper-cd-bc { padding: 0; }
	.bc-items {
		@media (max-width: @ms) {
			display: flex; align-items: center; width: calc(~'100% - -15px'); margin: 0; padding: 0; opacity: 1; overflow-y: hidden; white-space: normal; -webkit-overflow-scrolling: touch; position: relative;
			&::-webkit-scrollbar { display: none; }
			&::-webkit-scrollbar-thumb { display: none; }
		}
	}
	.bc-short {
		span:nth-last-child(2) a {
			margin-right: 0; padding-right: 0;
			&:after { content: none; }
		}
		.bc-last { display: none; }
	}
</style>
